(function () {
  if (window.__freeShippingProgressLoaded) return;
  window.__freeShippingProgressLoaded = true;

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' &&
        window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    const symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    const amount = (cents / 100).toFixed(2);
    return symbol ? `$${amount} ${symbol}` : `$${amount}`;
  }

  function update(el, cartTotalCents) {
    const threshold = parseInt(el.dataset.thresholdCents, 10);
    if (!threshold || Number.isNaN(threshold)) return;

    const remaining = Math.max(threshold - cartTotalCents, 0);
    const pct = Math.min(100, (cartTotalCents / threshold) * 100);
    const unlocked = cartTotalCents >= threshold;

    const fill = el.querySelector('[data-free-shipping-fill]');
    const message = el.querySelector('[data-free-shipping-message]');

    if (fill) fill.style.width = pct + '%';

    if (message) {
      if (unlocked) {
        message.textContent = el.dataset.unlockedTemplate || 'Free shipping unlocked!';
      } else {
        const tmpl = el.dataset.remainingTemplate || "You're {{ amount }} away from free shipping";
        message.textContent = tmpl
          .replace('{{ amount }}', formatMoney(remaining))
          .replace('{{amount}}', formatMoney(remaining));
      }
    }

    el.classList.toggle('free-shipping-progress--unlocked', unlocked);
  }

  async function refreshFromCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      const data = await res.json();
      document.querySelectorAll('[data-free-shipping-progress]').forEach((el) => {
        update(el, data.total_price);
      });
    } catch (_) { /* ignore */ }
  }

  // Hook into common cart events the theme/apps emit
  ['cart:updated', 'cart:refresh', 'cart-drawer:open'].forEach((name) => {
    document.addEventListener(name, refreshFromCart);
  });

  // Intercept native cart endpoints so we update even if the theme doesn't fire an event
  const origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (...args) {
      const result = origFetch.apply(this, args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(url)) {
          result.then(() => setTimeout(refreshFromCart, 50));
        }
      } catch (_) { /* ignore */ }
      return result;
    };
  }

  // Initial paint on load (in case cart was modified server-side before scripts attached)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshFromCart);
  } else {
    refreshFromCart();
  }
})();
